;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('PublicLinkController', PublicLinkController)

  /* @ngInject */
  function PublicLinkController (
    $scope,
    $rootScope,
    $timeout,
    $translate,
    $state,
    $q,
    ArtsService,
    ShareLinkService,
    ToastService,
    SegmentService,
    ModalService,
    AdminService,
    WideService
  ) {
    const getUseTermsListDialogController = () =>
      $q.when(import('../../dialogs/use-terms/list/use-terms-list-dialog.controller'))

    let oldComment = ''
    let oldDate = ''
    const userPagination = {
      index: 0,
      top: 20
    }

    $scope.createOptions = true

    $scope.showAdvancedSettings = true
    $scope.flags = {
      loadingDate: false,
      loadingComment: false,
      sendingInvites: false
    }
    $scope.form = {
      sharedLinkId: '',
      link: '',
      comment: '',
      expirationDate: null,
      usersToNotify: []
    }

    $scope.users = {
      count: null,
      emails: []
    }

    $scope.linkCopied = false
    $scope.searching = false

    $scope.newsEmails = []

    $scope.today = new Date().toISOString()

    const api = {
      getUseTermsListDialogController,
      _getSharedLink,
      _generateLink,
      _showUseTerms,
      _getUsers,
      _successGetUsers,
      _verifyWideEmail
    }
    this.getApi = () => api

    function activate () {
      if ($scope.art && $scope.art.id) {
        api._getSharedLink($scope.art.id).then(() => {
          if (!$scope.form.link) _generateLink($scope.art.id)
          oldComment = $scope.form.comment
          oldDate = $scope.form.date
        })
      }

      api._getUsers()
    }
    activate()

    const deregisterLoadPublicLinkData = $scope.$on('load-public-link-data', (e, data) => {
      $scope.art = data
      activate()
    })

    const deregisterPublicLinkCancelPublicLink = $scope.$on('publicLink.cancelPublicLink', () => {
      ShareLinkService.deleteShareLink($scope.form.sharedLinkId)
        .then(() => {
          $scope.form.sharedLinkId = null
          $scope.form.link = ''
          oldComment = ''
          $scope.form.comment = ''
          oldDate = null
          $scope.form.expirationDate = null
          $scope.buttons.disablePublicLink = false
          ToastService.showSuccessToast($translate.instant('sucessCancelLink'))
        })
        .catch(ToastService.defaultErrorToast)
    })

    const deregisterPublicLinkInvitePublicLink = $scope.$on('publicLink.invitePublicLink', () => {
      $timeout(() => {
        $scope.flags.sendingInvites = true
        $scope.sending = true
        ShareLinkService.sendInvites($scope.form.sharedLinkId, $scope.form.usersToNotify)
          .then(() => {
            ToastService.defaultSuccessToast()
            userPagination.index = 0
            api._getUsers()
          })
          .catch(() => {
            $scope.buttons.invitePublicLink = true
            ToastService.defaultErrorToast()
          })
          .finally(() => {
            $scope.flags.sendingInvites = false
            $scope.sending = false
          })
      }, 50)
    })

    const deregisterConfirmUseTermsToShareLink = $rootScope.$on('confirm-useTerms-to-shareLink', (e, artId) => {
      ModalService.close()
      api._generateLink(artId)
    })

    $scope.$on('$destroy', () => {
      deregisterLoadPublicLinkData()
      deregisterPublicLinkCancelPublicLink()
      deregisterPublicLinkInvitePublicLink()
      deregisterConfirmUseTermsToShareLink()
    })

    $scope.createNewEmail = function (event) {
      const email = event.detail.option

      const regexEmail = new RegExp(/\S+@\S+\.\S+/)

      const validEmail = regexEmail.test(email)

      if (validEmail) {
        $scope.newsEmails.push({ label: event.detail.option, value: event.detail.option })
        const emails = $scope.newsEmails.map(email => {
          return email.value
        })

        $scope.form.usersToNotify = emails

        api._verifyWideEmail(emails)

        return $timeout(() => {
          $scope.buttons.invitePublicLink = Boolean($scope.form.usersToNotify.length > 0 && $scope.form.link)
        })
      }

      ToastService.showErrorToast($translate.instant('invalidEmail'))
    }

    $scope.updateUsersToNotify = function (event) {
      $scope.createOptions = $scope.users.count === 0

      $scope.newsEmails = event.detail

      const emails = event.detail.map(info => {
        return info.value
      })

      $scope.form.usersToNotify = emails

      api._verifyWideEmail(emails)

      $timeout(() => {
        $scope.buttons.invitePublicLink = Boolean($scope.form.usersToNotify.length > 0 && $scope.form.link)
      })
    }

    $scope.showAdvancedSettingsClick = function () {
      $scope.showAdvancedSettings = !$scope.showAdvancedSettings
    }

    $scope.generateLink = artId => {
      if ($scope.art.useTermsId) {
        api._showUseTerms()
        return
      }
      api._generateLink(artId)
    }

    function _generateLink (artId) {
      ArtsService.canShareArt(artId).then(canShareArt => {
        if (!canShareArt) {
          ToastService.showErrorToast($translate.instant('sharedLinkBusinessDataError'))
        } else {
          ShareLinkService.createShareLink({
            artId,
            comment: $scope.form.comment,
            expirationDate: $scope.form.expirationDate
          })
            .then(() => {
              ArtsService.getPhotoframesCount($scope.art.id).then(photoframesCount => {
                let type

                if ($scope.art.customizationLevel === 'FREE_STYLE' || !$scope.art.customizationLevel) {
                  type = 'basic'
                } else if ($scope.art.customizationLevel === 'RESTRICTED') {
                  type = 'moderate'
                } else {
                  type = 'download'
                }

                $q.all([
                  ArtsService.getArtDetailById($scope.art.id),
                  ArtsService.getInfosBusinessData($scope.art.id)
                ]).then(([art, businessDataInfo]) => {
                  const place = $state.current.name
                  const productValue = !!document.querySelector('#canvas_group [data-product]')
                  SegmentService.track('shared-art', {
                    art_id: $scope.art.id,
                    sharing_type: 'public_link',
                    photoframes: photoframesCount,
                    permission: type,
                    template_id: art.baseTemplateId,
                    place,
                    format_type: $scope.art?.product?.type?.toLowerCase?.(),
                    business_data: businessDataInfo.hasPlaceholdersSaved,
                    video: art.hasVideo,
                    product: productValue,
                    carousel: false
                  })
                })
              })
              api._getSharedLink($scope.art.id)
              $timeout(() => {
                $scope.buttons.invitePublicLink = $scope.form.usersToNotify.length > 0 && $scope.form.link
              }, 50)
            })
            .catch(e => {
              if (e.data && e.data.code === 'ART_NOT_APPROVED') {
                ToastService.showErrorToast($translate.instant('pendingApprovalShare'))
              } else {
                ToastService.defaultErrorToast()
              }
            })
        }
      })
    }

    $scope.updateDate = function (event) {
      $scope.form.expirationDate = event.detail.date || null

      if ($scope.form.sharedLinkId && oldDate !== $scope.form.expirationDate) {
        const data = {
          expirationDate: $scope.form.expirationDate
        }
        $scope.flags.loadingDate = true
        ShareLinkService.update($scope.form.sharedLinkId, data)
          .then(() => {
            oldDate = $scope.form.date || $scope.form.expirationDate
          })
          .catch(() => {
            $scope.form.date = oldDate
            ToastService.defaultErrorToast()
          })
          .finally(() => {
            $scope.flags.loadingDate = false
          })
      }
    }

    $scope.updateComment = function (value) {
      if ($scope.form.sharedLinkId && oldComment !== $scope.form.comment) {
        $scope.form.loadingComment = true
        ShareLinkService.update($scope.form.sharedLinkId, { comment: value })
          .then(() => {
            oldComment = $scope.form.comment
          })
          .catch(() => {
            $scope.form.comment = oldComment
            ToastService.defaultErrorToast()
          })
          .finally(() => {
            $scope.flags.loadingComment = false
          })
      }
    }

    $scope.copyLink = link => {
      navigator.clipboard.writeText(link)
      ToastService.showSuccessToast($translate.instant('copied'))

      $scope.linkCopied = true

      $timeout(() => {
        $scope.linkCopied = false
      }, 5000)
    }

    $scope.onSearchUsers = event => {
      userPagination.index = 0
      api._getUsers(event.detail.search)
    }

    $scope.loadMoreUsers = () => {
      userPagination.index++
      api._getUsers()
    }

    function _getSharedLink (artId) {
      return ShareLinkService.getShareLink(artId).then(sharedLink => {
        if (sharedLink) {
          const instructions = $scope.art?.details?.suggestions || $scope.art?.suggestions
          $scope.form.sharedLinkId = sharedLink.id
          $scope.form.link = sharedLink.url
          $scope.form.comment = instructions || sharedLink.comment
          $scope.form.expirationDate = sharedLink.expirationDate ? moment(sharedLink.expirationDate) : null
          $scope.buttons.disablePublicLink = true
        }
      })
    }

    function _showUseTerms () {
      const oldModalReference = ModalService.getCurrentModal()
      api.getUseTermsListDialogController().then(({ UseTermsListDialogController }) => {
        ModalService.showModal({
          templateId: 'useTermsListDialog.html',
          templateUrl: '/arts/dialogs/use-terms/list/use-terms-list-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: UseTermsListDialogController,
          data: {
            useTermId: $scope.art.useTermsId,
            artId: $scope.art.id,
            useType: 'PUBLIC_LINK',
            pageShareArt: true,
            generateLink: true
          }
        }).then(() => {
          if (oldModalReference) {
            ModalService.setCurrentModal(oldModalReference)
          }
        })
      })
    }

    function _getUsers (search, notRecentsEmails = false) {
      const params = { search }

      if (search || notRecentsEmails) {
        $scope.searching = true

        AdminService.getUsersEmailsShareLinks(
          userPagination.top,
          userPagination.top * userPagination.index,
          params
        ).then(api._successGetUsers)
      } else {
        $scope.searching = false
        AdminService.getUsersEmailsRecentsShareLinks().then(api._successGetUsers)
      }
    }

    function _successGetUsers (results) {
      $scope.createOptions = results.count === 0
      $scope.users.count = $scope.searching ? results.count : 0
      $scope.users.emails = results.rows.map(user => {
        return {
          label: user.email,
          value: user.email
        }
      })
    }

    function _verifyWideEmail (emails) {
      const wideEmail = WideService.getWideEmail()
      if (emails.includes(wideEmail)) {
        const message = WideService.getMessageTemplate($rootScope.oUser.externalId)
        $scope.form.comment = message
      }
    }
  }
})()
